import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';

const primaryPalette = {
  light: '#757ce8',
  main: '#d2385f',
  contrastText: '#fff',
};

const secondaryPalette = {
  light: '#757ce8',
  main: '#be1085',
  contrastText: '#fff',
};

const primaryDarkPalette = {
  main: '#ffeb3b',
  dark: 'yellow',
  contrastText: '#ffeb3b',
};

export function getTheme(primaryColor) {
  if (primaryColor === 'style-contrast-yellow-black') {
    return responsiveFontSizes(createMuiTheme({
      palette: {
        primary: primaryDarkPalette,
        type: 'dark',
      },
      overrides: {
        MuiRadio: {
          colorPrimary: {
            color: primaryDarkPalette.main,
          },
        },
        MuiCheckbox: {
          colorPrimary: {
            color: primaryDarkPalette.main,
          },
        },
        MuiTextField: {
          root: {
            '& input:valid + fieldset': {
              borderColor: primaryDarkPalette.main,
            },
          },
        },
        MuiOutlinedInput: {
          root: {
            '& fieldset': {
              borderColor: primaryDarkPalette.main,
            },
          },
          input: {
            color: primaryDarkPalette.main,
          },
        },
        MuiInputBase: {
          root: {
            '& fieldset': {
              borderColor: primaryDarkPalette.main,
            },
          },
          input: {
            color: primaryDarkPalette.main,
          },
        },
        MuiInputLabel: {
          root: {
            color: primaryDarkPalette.main,
            opacity: 0.8,
          }
        },
        MuiMenuItem: {
          root: {
            color: primaryDarkPalette.main,
          },
        },
        MuiButton: {
          containedPrimary: {
            color: '#000',
          }
        },
        MuiTableCell: {
          head: {
            color: primaryDarkPalette.main
          },
          root: {
            color: primaryDarkPalette.main
          },
        },
        MuiTypography: {
          colorTextSecondary: {
            color: primaryDarkPalette.main
          }
        }
      }
    }));
  }

  return responsiveFontSizes(createMuiTheme({
    palette: {
      primary: {
        ...primaryPalette,
        main: primaryColor,
      },
      secondary: secondaryPalette
    }
  }));
}

export default responsiveFontSizes(createMuiTheme({
  palette: {
    primary: primaryPalette,
    secondary: secondaryPalette,
  }
}));


// WEBPACK FOOTER //
// ./src/styles/appTheme.js